// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"468":"b019cdb5","521":"d9aae804"}[chunkId] + ".chunk.js";
};